import { Component, OnInit, Input, OnChanges, SimpleChange, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';

import { AccountTypePipe } from "../account-type.pipe";

import { Domain as WebsideDomain } from "../../../../lib/Domain/Webside";
@Component({
  selector: 'app-account-infomation',
  templateUrl: './account-infomation.component.html',
  styleUrls: ['./account-infomation.component.css']
})
export class AccountInfomationComponent implements OnInit, OnChanges {
  @Output() Close = new EventEmitter();
  @Input() Item: WebsideDomain.IAccount = undefined;
  constructor() { }
  OnClose() {
    if (this.Close) {
      this.Close.emit();
    }
  }
  ngOnInit() {

  }
  ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    if (changes['Item'] && this.Item) { }
  }



}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/account-infomation/account-infomation.component.ts